import { baseApi, providesList } from '@/shared/api'
import type {
  NotificationList,
  NotificationsQuery,
  NotificationsReadBody,
  NotificationsReadResult,
} from '../model/types'

/**
 * Лента уведомлений и отметка прочитанными. Отбор (`unreadOnly`), страницы и счётчик непрочитанных
 * (`summary.unread`) приходят из API готовыми — на клиенте ничего не фильтруется и не считается.
 * Тот же тег `Notification` держит и новости (`entities/news`, id `NEWS`): лента ходит под id
 * `LIST`, поэтому отметка прочитанными новостей не трогает.
 */
export const notificationApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getNotifications: build.query<NotificationList, NotificationsQuery>({
      query: ({ page, pageSize, unreadOnly } = {}) => ({
        url: '/notifications',
        params: { page, pageSize, unreadOnly },
      }),
      providesTags: (res) => providesList(res?.items, 'Notification'),
    }),

    markNotificationsRead: build.mutation<NotificationsReadResult, NotificationsReadBody>({
      query: (body) => ({ url: '/notifications/read', method: 'POST', body }),
      // `readAt` и `summary.unread` — на бэке: перечитываем ленту и счётчик, а не правим число на клиенте.
      invalidatesTags: [{ type: 'Notification', id: 'LIST' }],
    }),
  }),
})

export const { useGetNotificationsQuery, useMarkNotificationsReadMutation } = notificationApi
